import styled from 'styled-components';
import LazyLoadImage from '../utilities/lazyload-image';
import GridWrapper from './marketplace-grid-wrappers.js';
import { Box, Small, Caption, LabelBold, HorizontalCard } from '@comeon/ui';

const SIZES = '180px';
const BODY_CONTENT_MAX_HEIGHT = '152px';
const ITEM_MAX_HEIGHT = '194px';

const StyledType = styled(Small)`
	white-space: nowrap;
`;

const StyledLabelBold = styled(LabelBold)`
	line-height: 1.2;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	overflow: hidden;
`;

const StyledCaption = styled(Caption)`
	-webkit-line-clamp: 5;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	overflow: hidden;
`;

const BodyContent = ({ cardHeaderTitle, cardHeaderCaption, cardBodyDescription }) => (
	<Box
		display="flex"
		flexDirection="column"
		justifyContent="center"
		height="100%"
		pr={[0, 0, 0, 5]}
		maxHeight={ITEM_MAX_HEIGHT}
	>
		<Box maxHeight={BODY_CONTENT_MAX_HEIGHT} overflow="hidden" pr={5}>
			<StyledType mb={3}>{cardHeaderCaption}</StyledType>
			<StyledLabelBold mb={2}>{cardHeaderTitle}</StyledLabelBold>
			{cardBodyDescription ? <StyledCaption>{cardBodyDescription}</StyledCaption> : null}
		</Box>
	</Box>
);

const MarketplaceItemCard = ({
	caption,
	title,
	content,
	alt,
	src,
	srcSet,
	pictureElementData,
	onClickHandler,
	href,
	to,
	dataAt,
	dataTestId,
	cardWrap,
	cardBottomContent,
	cardTopRightIcon,
	cardMediaChipText,
	cardMediaChipIcon,
	cardMediaChipTextDataAt,
	cardMediaChipIconDataAt
}) => (
	<GridWrapper
		gridRow="span 2"
		gridColumn="span 2"
		linkClassName="u-height-100"
		onClick={onClickHandler}
		href={href}
		to={to}
		data-testid={dataTestId}
	>
		<HorizontalCard
			overflow="hidden"
			mediaWithoutFlex
			biggerBorderRadius
			dataAt={dataAt}
			cardBodyContent={
				<BodyContent cardHeaderCaption={caption} cardHeaderTitle={title} cardBodyDescription={content} />
			}
			cardMediaImageComponent={
				<Box
					p="5"
					display="inline-flex"
					height="100%"
					overflow="hidden"
					className="shop-item-img"
					maxHeight={ITEM_MAX_HEIGHT}
					maxWidth={ITEM_MAX_HEIGHT}
				>
					<LazyLoadImage
						lazyload
						src={src}
						srcSet={srcSet}
						alt={alt}
						pictureElementData={pictureElementData}
						sizes={SIZES}
						style={{ aspectRatio: '1/1' }}
					/>
				</Box>
			}
			cardBottomContent={cardBottomContent}
			cardWrap={cardWrap}
			cardTopRightIcon={cardTopRightIcon}
			cardMediaChipText={cardMediaChipText}
			cardMediaChipIcon={cardMediaChipIcon}
			cardMediaChipTextDataAt={cardMediaChipTextDataAt}
			cardMediaChipIconDataAt={cardMediaChipIconDataAt}
		/>
	</GridWrapper>
);

export default MarketplaceItemCard;
